import { FC } from 'react';

import { useI18nContext } from '../../../hooks/contexts/i18n.context';
import * as Styles from './summary.styles';

const EXPLANATION = ['SUMMARY_FEES', 'EXPLANATION'];

/*
 * The same explanation the gateway checkout opens from its "?" — same sections, same order,
 * same copy (gateway `summary.po`) — so the buyer reads one story from the ticket list to the
 * payment step. The gateway's exchange-rate section is left out: it only applies to UYU and
 * depends on a quote the gateway fetches, which this page does not have. Only the fees are
 * explained: the discount section left both modals with MKT-1104.
 */
const SECTIONS = [
  {
    id : 'service-fee',
    title : ['SUMMARY_FEES', 'SERVICE_FEE'],
    description : [...EXPLANATION, 'SERVICE_FEE_DESCRIPTION'],
  },
  {
    id : 'processing-fee',
    title : [...EXPLANATION, 'PROCESSING_FEE'],
    description : [...EXPLANATION, 'PROCESSING_FEE_DESCRIPTION'],
  },
  {
    id : 'installment-interest',
    title : [...EXPLANATION, 'INSTALLMENT_INTEREST'],
    description : [...EXPLANATION, 'INSTALLMENT_INTEREST_DESCRIPTION'],
  },
];

const FeesExplanation: FC = () => {
  const { translate } = useI18nContext();

  return (
    <Styles.FeesExplanation id="summary-fees-explanation">
      {SECTIONS.map(({ id, title, description }) => (
        <Styles.FeesExplanationSection key={id} id={`summary-fees-explanation-${id}`}>
          <Styles.FeesExplanationTitle>{translate(title)}</Styles.FeesExplanationTitle>
          <Styles.FeesExplanationText>{translate(description)}</Styles.FeesExplanationText>
        </Styles.FeesExplanationSection>
      ))}
    </Styles.FeesExplanation>
  );
};

export default FeesExplanation;
